
import * as React from "react";
import { useSidebar, SIDEBAR_WIDTH_MOBILE } from "./SidebarProvider";
import { SidebarDesktop } from "./components/SidebarDesktop";
import { SidebarMobile } from "./components/SidebarMobile";
import { SidebarSimple } from "./components/SidebarSimple";

export const Sidebar = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<"div"> & {
    side?: "left" | "right";
    variant?: "sidebar" | "floating" | "inset";
    collapsible?: "offcanvas" | "icon" | "none";
  }
>(
  (
    {
      side = "left",
      variant = "sidebar",
      collapsible = "offcanvas",
      className,
      children,
      ...props
    },
    ref
  ) => {
    const { isMobile, state, openMobile, setOpenMobile } = useSidebar();

    // If collapsible is "none", render a simple non-collapsible sidebar
    if (collapsible === "none") {
      return (
        <SidebarSimple 
          className={className} 
          ref={ref} 
          {...props}
        >
          {children}
        </SidebarSimple>
      );
    }

    // Mobile sidebar uses Sheet component
    if (isMobile) {
      return (
        <SidebarMobile
          ref={ref}
          side={side}
          openMobile={openMobile}
          setOpenMobile={setOpenMobile}
          width={SIDEBAR_WIDTH_MOBILE}
          {...props}
        >
          {children}
        </SidebarMobile>
      );
    }

    // Desktop sidebar with various display options
    return (
      <SidebarDesktop
        ref={ref}
        collapsible={collapsible}
        side={side}
        variant={variant}
        state={state}
        className={className}
        {...props}
      >
        {children}
      </SidebarDesktop>
    );
  }
);

Sidebar.displayName = "Sidebar";
